import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fkqy",
  "use": "icon-fkqy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fkqy\"><path d=\"M273.664 681.386667L706.389333 248.704l-60.330666-60.330667L213.333333 621.056v60.373333h60.330667z m35.370667 85.333333H128v-180.992L615.893333 97.834667a42.666667 42.666667 0 0 1 60.330667 0l120.704 120.661333a42.666667 42.666667 0 0 1 0 60.373333L309.034667 766.72zM128 852.053333h768v85.333334H128v-85.333334z\" p-id=\"1655\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol